import { render, staticRenderFns } from "./btnStatus.vue?vue&type=template&id=887c82e8&scoped=true&"
import script from "./btnStatus.vue?vue&type=script&lang=js&"
export * from "./btnStatus.vue?vue&type=script&lang=js&"
import style0 from "./btnStatus.vue?vue&type=style&index=0&id=887c82e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887c82e8",
  null
  
)

export default component.exports